var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-block__splashscreen",class:{
    primary:
      _vm.$voicer.getConfig('enabledSplashScreen') ||
      _vm.$voicer.getConfig('enabledSplashScreen.mode') === 'classic',
  }},[_c('img',{attrs:{"src":require('~/assets/images/Logo-Radio-Papilles.png'),"width":"300"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }